import { DefaultService } from '../../common/services/DefaultService';
import * as $ from 'jquery';
import { apiBaseUrlUser } from '../../../constants/url.constant';
import { AddCartItemModel, EditCartItemModel } from '../models/CartModel';

export class CartService extends DefaultService {
    private baseUrl = `${apiBaseUrlUser}/cart`

    public RouteGetUserCartId = () => `${this.baseUrl}/getUserCartId`;
    public getUserCartId(): JQueryPromise<any> {
        return $.ajax(this.RouteGetUserCartId(), {
            type: 'get',
            contentType: 'application/json'
        });
    }

    public RouteGet = (cartId: number, sortBy: string, sortDirection: string) =>
        `${this.baseUrl}/get/${cartId}?sortBy=${sortBy}&&sortDirection=${sortDirection}`;

    public get(cartId: number, sortBy: string, sortDirection: string): JQueryPromise<any> {
        return $.ajax(this.RouteGet(cartId, sortBy, sortDirection), {
            type: 'get',
            contentType: 'application/json'
        });
    }

    public RouteGetCount = (cartId: number) => `${this.baseUrl}/getCount/${cartId}`;

    public getCount(cartId: number): JQueryPromise<any> {
        return $.ajax(this.RouteGetCount(cartId), {
            type: 'get',
            contentType: 'application/json'
        });
    }
}

export class CartItemService extends DefaultService {
    private baseUrl = `${apiBaseUrlUser}/cartItem`

    public RouteAdd = () => `${this.baseUrl}/create`;
    public add(model: AddCartItemModel): JQueryPromise<any> {
        return $.ajax(this.RouteAdd(), {
            type: 'post',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteEdit = (cartId: number) => `${this.baseUrl}/edit/${cartId}`;
    public edit(cartId: number, model: EditCartItemModel): JQueryPromise<any> {
        return $.ajax(this.RouteEdit(cartId), {
            type: 'put',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteDelete = (id: number, cartId: number) => `${this.baseUrl}/delete/${id}?cartId=${cartId}`;
    public delete(id: number, cartId: number): JQueryPromise<any> {
        return $.ajax(this.RouteDelete(id, cartId), {
            type: 'delete',
            contentType: 'application/json'
        });
    }
}